export default "__VITE_ASSET__C9sNwzN9__"